import { gql } from '@apollo/client';

export const PERSONAL_RESULTS = gql`
  query personalResults($personalId: PersonalId!) {
    client {
      id
      employee(personalId: $personalId) {
        id
        personalId
        regularHealthCheckupResults {
          id
          dateOn
        }
      }
    }
  }
`;

export interface PersonalResultsQueryVariables {
  personalId: string;
}

export interface PersonalResultsQueryResult {
  client: {
    employee: Employee;
  };
}

export interface Employee {
  id: string;
  personalId: string;
  regularHealthCheckupResults: PartialRegularHealthCheckupResult[];
}

export interface PartialRegularHealthCheckupResult {
  id: string;
  dateOn: string;
}

export const DELETE_REGULAR_HEALTH_CHECKUP_RESULT = gql`
  mutation deleteRegularHealthCheckupResult($input: DeleteRegularHealthCheckupResultInput!) {
    deleteRegularHealthCheckupResult(input: $input) {
      id
    }
  }
`;

export interface DeleteRegularHealthCheckupResultQueryVariables {
  input: {
    personalId: string;
    resultId: string;
  };
}

export interface DeleteRegularHealthCheckupResultQueryResult {
  deleteRegularHealthCheckupResult: {
    id: string;
  };
}
